<div class="container homes-wrapper">
  <h2>homes</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" href="#">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" href="#">homes</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>

        <input
          id="equipmentTitle"
          (change)="onTitleChange($event)"
          matInput
          placeholder="Add Equipment"
          value="{{ home_title }}"
        />
      </mat-form-field>
      <span *ngIf="titleError" style="color: red">{{ titleError }}</span>
    </div>
  </form>

  <button
    (click)="Add($event)"
    mat-flat-button
    color="primary"
    class="add-new-btn"
  >
    <mat-icon>add</mat-icon> Add homes
  </button>
  <div *ngFor="let home of items">
    <div class="homes-wrapper__item">
      <div class="d-flex flex-wrap">
        <div class="homes-wrapper__item__image">
          <img src="../../assets/images/list-image.jpg" alt="" />
        </div>
        <div class="flex-grow-1 flex-column d-flex">
          <h2 class="homes-wrapper__item__title">{{ home.home_title }}</h2>
          <p class="homes-wrapper__item__detail">
            {{ home.home_detail }}<br />
            {{ home.contractor_detail }}
          </p>
          <div class="mt-auto">
            <button
              mat-flat-button
              class="mt-auto me-3 view-homes"
              color="accent"
            >
              View homes
            </button>
            <button mat-flat-button class="mt-auto set-homes" color="primary">
              Set homes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
